import React, { useState, useEffect, useRef } from 'react'
import FeaturedStories from './FeaturedStories'
import Stories from './Stories'
import ProgressDialog from '../CollectionsPage/ProgressDialog'
import api from '../exhibitApi'

export default function StoryFeedMain(props) {
  const { app, collections, skip, moveToTop } = props

  const [featuredCollections, setFeaturedCollections] = useState(collections)
  const [stories, setStories] = useState([])
  const [featuredStories, setFeaturedStories] = useState([])
  const [showProgressDialog, setShowProgressDialog] = useState(false)
  const exhibitId = app._id
  const getPageOfStories = useRef()

  useEffect(() => {
    const pager = api.story().getPager({ exhibitId, order: app.storiesOrder, limit: 20, featured: false })
    getPageOfStories.current = pager.getPageOfStories
  }, [api, exhibitId])

  useEffect(() => {
    async function fetchFeaturedStories(id) {
      const newStories = await api.story().getFeaturedByExhibitId(id)
      setFeaturedStories(newStories)
    }

    fetchFeaturedStories(exhibitId)
  }, [api, exhibitId])

  useEffect(() => {
    async function fetchStoriesNotFeatured(_skip) {
      setShowProgressDialog(true)

      const newStories = await getPageOfStories.current()
      setStories([...stories, ...newStories])
      setShowProgressDialog(false)
    }

    fetchStoriesNotFeatured(skip)
  }, [skip, exhibitId])

  useEffect(() => {
    if (collections.length > 0) {
      const featured = collections.filter((c) => c.featured === true)
      setFeaturedCollections(featured)
    }
  }, [collections])

  const handleShowStory = (storyId) => {
    props.history.push(`${props.match.url}/story/${storyId}`)
    moveToTop()
  }

  return (
    <>
      <FeaturedStories
        featuredCollections={featuredCollections}
        featuredStories={featuredStories}
        showStory={handleShowStory} />

      <Stories stories={stories} showStory={handleShowStory} />
      <ProgressDialog show={showProgressDialog} right bottom={70} />
    </>
  )
}
